import { useEffect, useMemo, useState } from 'react'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { FormsTabs } from '../../components/FormTabs/FormsTabs.Component'
import { FormSubmittedPage } from '../FormSubmittedPage/FormSubmitted.Page'
import { getDomainsMaster } from '../../service/masterService'
import { DomainTab } from '../../components/DomainTab/DomainTab.Component'
import { SelectServiceModal } from '../../components/Modals/SelectService/SelectService.Modal'
import { FormFooter } from '../../layout/Footer/FormFooter'
import { BusinessDetailsForm } from '../../components/BusinessDetailsForm/BusinessDetailsForm.Component'
import { UploadDocumentForm } from '../../components/UploadDocumentForm/UploadDocumentForm.Component'
import { ReviewDetailsForm } from '../../components/ReviewDetailsForm/ReviewDetailsForm.Component'
import { useDispatch, useSelector } from 'react-redux'
import { mandatoryValidationError } from '../../utils/errors'
import { skeletonArray } from '../../helpers/numbers'
import { getImageUrl } from '../../utils/images'
import { getErrorMessage, submitOnboardingForm } from '../../service/onboardingService'
import { showMessage, showSpinner } from '../../utils/alerts'
import Swal from 'sweetalert2'
import { isEmail } from '../../helpers/string'
import { onboardFormActions } from '../../store/onboardFormState'


export const OnboardingFormPage = () => {

  const dispatch = useDispatch()

  const [currentTab, setCurrentTab] = useState(1)

  const [isSubmitted, setIsSubmitted] = useState(false)

  const [diableButtons, setDiableButtons] = useState(false)

  const [domains, setDomains] = useState([])

  const [selectedDomain, setSelectedDomain] = useState()

  const [showServiceModal, setShowServiceModal] = useState(false)

  const [isAllPhoneValid, setIsAllPhoneValid] = useState(false)

  const [isEmailsUnique, setIsEmailsUnique] = useState(false)

  const [appId, setAppId] = useState("")

  const formData = useSelector(state => state.onboardForm)

  const isAuditServicesSelected = formData.domains.some(domain =>
  ["audit", "services"].every(keyword =>
    domain.name.toLowerCase().includes(keyword)
  )
);
useEffect(()=>
{
 dispatch(onboardFormActions.resetForm())
},[])

  const [tabsData, setTabsData] = useState([
    "Domain details",
    "Business Details",
    "Documents",
    "Review",
  ])

  const getDomainData = async () => {
    const res = await getDomainsMaster()
    if (res?.status == 200) {
      setDomains(res.data.category)
    }
  }

  const openServiceModal = (domain) => {
    setSelectedDomain(domain)
    setShowServiceModal(true)
  }

 const checkFormFieldsValidation = () => {
  const mandatoryFields = document.getElementsByClassName("mandatory");
  let allFieldCaptured = true;
  let firstValidationField;

  const emailFields = document.querySelectorAll('input[type="email"]');

  emailFields.forEach((emailField) => {
    if (emailField.nextElementSibling?.classList.contains("validation-error")) {
      emailField.nextElementSibling.remove();
    }
  });

 
  for (let i = 0; i < mandatoryFields.length; i++) {
    const field = mandatoryFields[i];

    const isEmailField =
      field.type === "email" &&
      (field.ariaValueNow === "Email address" ||
        field.ariaValueNow === "Primary email address");

    if (field.value === "" || field.value === "Select") {
      const tempSpan = document.createElement("span");
      tempSpan.classList.add("validation-error");
      tempSpan.innerHTML = getErrorMessage(field);

      if (!field?.nextElementSibling?.classList.contains("validation-error")) {
        field.insertAdjacentElement("afterend", tempSpan);
        field.addEventListener("change", () => tempSpan?.remove());
      }

      if (allFieldCaptured) firstValidationField = field;
      allFieldCaptured = false;
      continue;
    }

   
    if (field.type === "email" && !isEmail(field.value)) {
      const tempSpan = document.createElement("span");
      tempSpan.classList.add("validation-error");
      tempSpan.innerHTML = `Please enter a valid email`;

      if (!field?.nextElementSibling?.classList.contains("validation-error")) {
        field.insertAdjacentElement("afterend", tempSpan);
        field.addEventListener("change", () => tempSpan?.remove());
      }

      if (allFieldCaptured) firstValidationField = field;
      allFieldCaptured = false;
      continue;
    }

    
    if (isEmailField) {
   

      if (!isEmailsUnique) {
    

        emailFields.forEach((emailField) => {
          emailField.nextElementSibling?.classList.contains("validation-error") &&
            emailField.nextElementSibling.remove();
        });

        continue; 
      }

      const tempSpan = document.createElement("span");
      tempSpan.classList.add("validation-error");
      tempSpan.innerHTML = `The business email address and primary email address must be different.`;

      if (!field?.nextElementSibling?.classList.contains("validation-error")) {
        field.insertAdjacentElement("afterend", tempSpan);
        field.addEventListener("change", () => tempSpan?.remove());
      }

      if (allFieldCaptured) firstValidationField = field;
      allFieldCaptured = false;
    }
  }

  if (allFieldCaptured && isAllPhoneValid && !isEmailsUnique) {
    return setCurrentTab(3);
  }

  firstValidationField?.focus();

};


 const checkMandatoryDocumentsValidation = () => {

  const hasAuditService = formData.domains?.some(domain =>
    domain.subCategory?.some(sub => sub.name === "Audit Services")
  );

  const documents = hasAuditService
    ? formData.documents
    : formData.documents?.filter(doc => !doc.visibleForAuditOnly);

  let allMandatoryDocsUploaded = true;

  for (let i = 0; i < documents.length; i++) {
    if (documents[i].mandatory && documents[i].docId === "") {
      allMandatoryDocsUploaded = false;
      mandatoryValidationError(documents[i].name);
      break;
    }
  }

  if (allMandatoryDocsUploaded) {
    setCurrentTab(4);
  }
};

  const submitForm = async () => {
    showSpinner("Submitting", "Your application submission is in progress.")
    setDiableButtons(true)
    const response = await submitOnboardingForm(formData)
    if (response?.status === 200) {
      Swal.close()
      if (response.data?.status === false) {
        showMessage("Application cannot be submitted.", response?.data?.message)
        setDiableButtons(false)
      }
      if (response.data?.APPLICATION_NUMBER===0) {
        showMessage("Application cannot be submitted.", response?.data?.message)
        setDiableButtons(false)
      }
      if (response.data?.APPLICATION_NUMBER) {
        setAppId(response.data.APPLICATION_NUMBER)
        setIsSubmitted(true)
        setDiableButtons(false)
        setCurrentTab(1)
        dispatch(onboardFormActions.resetForm())
      }
    }
    else{
      showMessage("Something went wrong.", (response?.data?.message ? response?.data?.message : "Please try again."))
      setDiableButtons(false)
    }
  }

  useMemo(() => {
    getDomainData()
  }, [])


  const hasAuditService = formData.domains?.some(domain =>
  domain.subCategory?.some(sub => sub.name === "Audit & Assurance")
);

const documentsToCheck = hasAuditService
  ? formData.documents
  : formData.documents?.filter(doc => !doc.visibleForAuditOnly);


const disableNext = documentsToCheck?.some(
  doc => doc.mandatory && !doc.url
);



  return (
    isSubmitted ? <FormSubmittedPage appId={appId} /> :
      <div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-md-12 px-0">
              <div className="left-title-bg">
                <p className="left-title">Partner Registration</p>
                {/* <p className="left-title">Step {currentTab}</p> */}
              </div>
              <div className="content step1-bg">
                <div className="mb-40">
                  <a href="#">
                    <img
                      src={getImageUrl("logo-dark.svg")}
                      alt="img"
                      className="w-200p"
                    />
                  </a>
                </div>

                <div className="wizard">
                  <div className="wizard-inner">
                    <FormsTabs selectedTab={currentTab} tabs={tabsData} setCurrentTab={setCurrentTab} />
                  </div>
                  <div className="tab-content mt-4">
                    <div className={`tab-pane ${currentTab == 1 ? "active" : ""}`} id="step1">
                      <p className="mb-0 font-20 font-md-30 font-weight-800">
                        Business Domain
                      </p>
                      <p>
                        Please select your business domain below.
                       
                      </p>
                      <div className="row mt-4">

                        {
                          domains.length ?
                            domains.map((d) =>
                              <DomainTab key={d?.id} index={d?.id} domain={d} img={d.filePath} showService={openServiceModal} />
                            ) :
                            skeletonArray(4).map((v, idx) => <div key={idx} className="col-12 col-md-3">{<Skeleton style={{ height: "200px" }} />}</div>)
                        }
                      </div>
                      <div className="my-40">
                        <button type="button" dis className="btn btn-default next-step" onClick={() => {
                        
                           
                          setCurrentTab(2);
                     
                          dispatch(onboardFormActions.updateDocuments(formData.domains));
                        
                        }}
                          disabled={formData.domains.length ? false : true}
                        >
                          Next Step
                        </button>
                      </div>
                    </div>
                    <div className={`tab-pane ${currentTab == 2 ? "active" : ""}`} id="step2">
                      <p className="mb-0 font-20 font-md-30 font-weight-800">
                        About your Business
                      </p>
                      <p>
                        Please enter your business details below.
                     
                      </p>
                      <BusinessDetailsForm isAllPhoneValid={isAllPhoneValid} setIsAllPhoneValid={setIsAllPhoneValid} isEmailsUnique={isEmailsUnique} setIsEmailsUnique={setIsEmailsUnique}/>
                      <div className="my-40">
                        <button type="button" className="btn btn-light prev-step" onClick={() => {checkFormFieldsValidation();setCurrentTab(1)}}>
                          Back
                        </button>
                        <button type="button" className="btn btn-default next-step" onClick={checkFormFieldsValidation}>
                          Next Step
                        </button>
                      </div>
                    </div>
                    <div className={`tab-pane ${currentTab == 3 ? "active" : ""}`} id="step3">
                      <p className="mb-0 font-20 font-md-30 font-weight-800">
                        Documents Required
                      </p>
                      <p>
                        Please upload documents for the required category.
                      </p>
                      <UploadDocumentForm />


                      {isAuditServicesSelected  &&                       <div
    style={{
      marginTop: "20px",
      padding: "15px",
      border: "1px solid #ccc",
      borderRadius: "8px",
      background: "#f8f9fa",
    }}
  >
    <strong>Note:</strong>
  <p style={{ marginTop: "8px", lineHeight: "22px" }}>
  Since you have selected <strong>Financial Audit Services</strong>, please ensure you
  download, complete, and sign the{" "}
  <a
    href={getImageUrl("dcc_registration_application_form_for_audit_firms")}
    download
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "#2563eb", fontWeight: 600, textDecoration: "underline" }}
  >
    Audit Firm Document (Download here)
  </a>.
  Upload this document along with the following mandatory supporting documents.
</p>

    <ul style={{ marginTop: "10px", lineHeight: "24px" }}>
      <li><strong>CVs / Staff Profile – List of Key Staff</strong> (mandatory, up to 3)</li>
      <li>
        <strong>Client’s Affiliation Certificate with International Firm</strong> 
        {" "}(Applicable if selected <strong>YES</strong> in Section II of Audit Firm Document.)
      </li>
      <li>
        <strong>Proof of Registration with other Freezones</strong> 
        {" "}(Applicable if selected <strong>YES</strong> in Section II of Audit Firm Document.)
      </li>
      <li>
        <strong>Proof of Registration with UAE Banks</strong> 
       {" "} (Applicable if selected <strong>YES</strong> in Section II of Audit Firm Document.)
      </li>
    </ul>

    <p style={{ marginTop: "8px", lineHeight: "22px" }}>
      You can click on the <strong>Upload Additional Documents</strong> box to upload these documents.
    </p>

   
  </div>
}




                      <div className="my-40">
                        <button type="button" className="btn btn-light prev-step" onClick={() => setCurrentTab(2)}>
                          Back
                        </button>

                                               
                        <button type="button" className="btn btn-default next-step"  onClick={checkMandatoryDocumentsValidation}
    disabled={disableNext} >
                          Next Step
                        </button>
                      </div>
                    </div>
                    <div className={`tab-pane ${currentTab == 4 ? "active" : ""}`} id="step4">
                      <ReviewDetailsForm diableButtons={diableButtons}/>
                      <div className="my-40">
                        <button type="button" disabled={diableButtons} className="btn btn-light prev-step" onClick={() => setCurrentTab(3)}>
                          Back
                        </button>
                        <button type="button" disabled={formData.undertakings?.some((u) => !u.checked) || diableButtons} className="btn btn-default" onClick={submitForm}>
                          {diableButtons ? "Please wait..." : "Finish"}
                        </button>
                      </div>
                    </div>
                    <div className="clearfix" />
                  </div>
                </div>
              </div>
            </div>
            <FormFooter />
          </div>
        </div>
        <SelectServiceModal show={showServiceModal} domain={selectedDomain} close={setShowServiceModal} />
      </div>
  )
}